import React from 'react'
import { KTIcon } from '../../../../../../../_metronic/helpers'
import { IProviderBase } from '../../core/types'
import { convertUTCtoMSK } from '../../../../../../../utils'

interface Props {
  provider: IProviderBase
  isDetailsLoading: boolean
  onOpenSettings: (provider: IProviderBase) => void
  onToggle: (providerId: number) => void
}

export default ({ provider, isDetailsLoading, onOpenSettings, onToggle }: Props) => {
  return (
    <tr>
      <td className='fw-bold'>{provider.name}</td>
      <td>
        <button
          type='button'
          className={`btn btn-sm ${provider.enabled ? 'btn-light-success' : 'btn-light-danger'} min-w-90px px-2 py-1`}
          onClick={() => onToggle(provider.id)}
        >
          {provider.enabled ? 'Включён' : 'Выключен'}
        </button>
      </td>
      <td>
        <span className={`badge ${provider.externalGateway ? 'badge-light-info' : 'badge-light-secondary'}`}>
          {provider.externalGateway ? 'Да' : 'Нет'}
        </span>
      </td>
      <td>
        <span className='text-muted fw-semibold'>{provider.lastTransactionAt? convertUTCtoMSK(provider.lastTransactionAt.replace(' ', 'T') + 'Z') : '-'}</span>
      </td>
      <td>{provider.totalDeposits}</td>
      <td>{provider.totalPayouts}</td>
      <td>{provider.activeMerchantsCount}</td>
      <td>{provider.credentialsCount}</td>
      <td>
        <span className='text-muted fw-semibold'>{convertUTCtoMSK(provider.createdAt.replace(' ', 'T') + 'Z')}</span>
      </td>
      <td>
        <span className='text-muted fw-semibold'>{convertUTCtoMSK(provider.updatedAt.replace(' ', 'T') + 'Z')}</span>
      </td>
      <td className='text-end'>
        {provider.credentialsRequired && (
          <button
            type='button'
            className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
            title='Настроить связки'
            onClick={() => onOpenSettings(provider)}
            disabled={isDetailsLoading}
          >
            {isDetailsLoading
              ? <span className='spinner-border spinner-border-sm' />
              : <KTIcon iconName='setting-2' className='fs-3' />
            }
          </button>
        )}
      </td>
    </tr>
  )
}
